<template>
  <div class="vx-row justify-content-center mt-2 mb-2">

    <div class="vx-col w-1/3">
      <div class="vx-row justify-content-center">
        <vue-circle
          :progress="relationship"
          :size="60"
          :reverse="false"
          line-cap="round"
          :fill="fill"
          empty-fill="rgba(0, 0, 0, .1)"
          :animation-start-value="0.0"
          :start-angle="0"
          insert-mode="append"
          :thickness="10"
          :show-percent="true"
          @vue-circle-progress="progress_circle"
          @vue-circle-end="progress_end_circle">
        </vue-circle>
        <div class="w-full text-center">
          <span class="font-bold" style="font-size: 10px;">{{ $t("coach.coachingExperienceChart.cec1") }}</span>
        </div>
      </div>
    </div>

    <div class="vx-col w-1/3">
      <div class="vx-row justify-content-center">
        <vue-circle
          :progress="resourceAvailability"
          :size="60"
          :reverse="false"
          line-cap="round"
          :fill="fill"
          empty-fill="rgba(0, 0, 0, .1)"
          :animation-start-value="0.0"
          :start-angle="0"
          insert-mode="append"
          :thickness="10"
          :show-percent="true"
          @vue-circle-progress="progress_circle"
          @vue-circle-end="progress_end_circle">
        </vue-circle>
        <div class="w-full text-center">
          <span class="font-bold" style="font-size: 10px;">{{ $t("coach.coachingExperienceChart.cec2") }}</span>
        </div>
      </div>
    </div>

    <div class="vx-col w-1/3">
      <div class="vx-row justify-content-center">
        <vue-circle
          :progress="managerSupport"
          :size="60"
          :reverse="false"
          line-cap="round"
          :fill="fill"
          empty-fill="rgba(0, 0, 0, .1)"
          :animation-start-value="0.0"
          :start-angle="0"
          insert-mode="append"
          :thickness="10"
          :show-percent="true"
          @vue-circle-progress="progress_circle"
          @vue-circle-end="progress_end_circle">
        </vue-circle>
        <div class="w-full text-center">
          <span class="font-bold" style="font-size: 10px;">{{ $t("coach.coachingExperienceChart.cec3") }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import VueCircle from 'vue2-circle-progress';
import VueCircle from 'vue2-circle-progress/src/index.vue'

export default {
  name: "ProgressMeasureChart",
  props: ["managerSupport", "relationship", "resourceAvailability"],
  components: {
    VueCircle
  },
  methods: {
    progress_circle(event,progress,stepValue){
      console.log(stepValue);
    },
    progress_end_circle(event){
      console.log("Circle progress end");
    }
  },
  // props: ['relevancy', 'progress', 'practice'],
  data() {
    return {
      fill: {gradient: ["#079E9A", "#76C488", "#9DCD5B"]},
      /*rel: [this.relevancy],
      prog: [this.progress],
      prac: [this.practice],*/
    }
  }
};
</script>

<style scoped>
  .justify-content-center{
    justify-content: center;
  }
</style>
